export enum StaticDataGroups {
	GeneralDetails = "generalDetails",
	LCT = "lowCarbonTech",
	GenerationCount = "generationCounts",
	GeneratorAndStorage = "generatorAndStorage",
	NetworkCapacity = "networkCapacity",
}
